import React, { useEffect, useState, useCallback } from "react";
import { CCard, CCardBody, CCardHeader, CButton, CRow, CCol } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilX, cilPin } from "@coreui/icons";
import { listPins, removePin } from "../../api/pinsApi";
import { renderToolResult } from "../Assistant/ToolResultView";
import { SkeletonCard } from "../UI/Skeleton/Skeleton";

export default function PinnedInsightsSection({ serverId }) {
  const [pins, setPins] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    if (!serverId) return;
    setLoading(true);
    listPins(serverId)
      .then((data) => setPins(data?.pins || []))
      .catch(() => setPins([]))
      .finally(() => setLoading(false));
  }, [serverId]);

  useEffect(() => {
    load();
  }, [load]);

  const handleRemove = async (pinId) => {
    setPins((prev) => prev.filter((p) => p.id !== pinId));
    try {
      await removePin(pinId);
    } catch {
      load();
    }
  };

  if (loading) {
    return (
      <CRow className="g-3 mb-4">
        {[0, 1].map((i) => (
          <CCol xs={12} md={6} key={i}>
            <SkeletonCard lines={3} />
          </CCol>
        ))}
      </CRow>
    );
  }

  if (pins.length === 0) return null;

  return (
    <div className="mb-4">
      <h6 className="d-flex align-items-center gap-2 mb-3">
        <CIcon icon={cilPin} /> Закреплено
      </h6>
      <CRow className="g-3">
        {pins.map((pin) => (
          <CCol xs={12} md={6} key={pin.id}>
            <CCard className="h-100">
              <CCardHeader className="d-flex align-items-center justify-content-between py-2">
                <span className="small fw-semibold">{pin.title}</span>
                <CButton size="sm" color="secondary" variant="ghost" onClick={() => handleRemove(pin.id)} title="Открепить">
                  <CIcon icon={cilX} />
                </CButton>
              </CCardHeader>
              <CCardBody className="py-2">{renderToolResult(pin.tool_name, pin.payload)}</CCardBody>
            </CCard>
          </CCol>
        ))}
      </CRow>
    </div>
  );
}
